import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { Grid, Paper, Tab, Tabs, Typography, units } from '@hbf/dsl';
import { ContentfulImg } from 'ha/modules/Contentful/components/ContentfulImg';
import { VpTabsComponentData } from './types';

const useStyles = makeStyles()(theme => ({
  title: {
    marginBottom: units.rem(1),
    [theme.breakpoints.up('md')]: {
      marginBottom: units.rem(1.5),
    },
  },
  descriptionContainer: {
    [theme.breakpoints.down('md')]: {
      marginBottom: units.rem(1.5),
    },
  },
  container: {
    marginBottom: units.rem(2.5),
  },
  paper: {
    marginTop: units.rem(1.5),
    marginBottom: units.rem(1.5),
  },
  image: {
    maxWidth: '100%',
    [theme.breakpoints.up('md')]: {
      width: units.rem(47.5),
      height: units.rem(26.25),
      backgroundSize: 'cover',
    },
  },
  text: {
    maxWidth: units.rem(35),
  },
  tabs: {
    width: '100%',
  },
}));

export interface Props {
  valueProposition: VpTabsComponentData;
}

export const VpTabs: React.FC<Props> = ({ valueProposition }) => {
  const { classes } = useStyles();
  const [currentTab, setCurrentTab] = React.useState(0);

  const handleTabChange = React.useCallback(
    (_: React.ChangeEvent<HTMLSelectElement>, newTab: number) => {
      setCurrentTab(newTab);
    },
    [],
  );

  const currentTabData = valueProposition.tabs[currentTab];

  return (
    <Grid container direction="column" className={classes.container}>
      <Grid item container>
        <Tabs
          value={currentTab}
          onChange={handleTabChange}
          indicatorColor="secondary"
          variant="scrollable"
          scrollButtons="auto"
          className={classes.tabs}
        >
          {valueProposition.tabs.map((tab, i) => {
            return <Tab label={tab.title} key={i} />;
          })}
        </Tabs>
      </Grid>

      <Grid item container direction="column" alignItems="center">
        <Paper className={classes.paper} elevation={3}>
          <ContentfulImg
            isResponsive
            src={currentTabData.imageMobile}
            className={classes.image}
            sizes={{ md: '760px' }}
          />
        </Paper>
        <Typography.Paragraph align="center" className={classes.text}>
          {currentTabData.description}
        </Typography.Paragraph>
      </Grid>
    </Grid>
  );
};
